import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { SEARCH_MEMBERS_QUERY } from '@frontend/app/queries';
import {
  SearchMembersQuery,
  SearchMembersQueryVariables,
} from '@frontend/app/queries/types/SearchMembersQuery';

/**
 * Hook for searching members by search term
 * @param value Search term to filter members by name
 * @returns Object with members data, loading state, and error
 */
export const useSearchMembers = (value: string) => {
  const { data, loading, error } = useQuery<SearchMembersQuery, SearchMembersQueryVariables>(
    SEARCH_MEMBERS_QUERY,
    {
      variables: {
        query: {
          fields: {
            or: [
              ...((!value || value.length === 0) ? [] : [{ contains: value, column: 'name' }]),
            ],
          },
        },
        take: 100,
        skip: 0,
      },
      skip: !value,
      fetchPolicy: 'no-cache',
    }
  );

  // Memoize the result to prevent unnecessary re-renders
  const result = useMemo(() => ({
    data,
    loading,
    error
  }), [data, loading, error]);

  return result;
};
